import { useLocalSearchParams } from 'expo-router';
import TeamDetailLayout from '@/layouts/TeamDetail';

export default function PrivateTabsOrganizationTeamTeamIdLayoutRoute() {
  const { teamId } = useLocalSearchParams<{ teamId: string }>();

  return (
    <TeamDetailLayout
      basePath="/organization/team/[teamId]"
      badgesPathname="/organization/team/[teamId]/badge"
      teamId={teamId}
    />
  );
}
